import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageWK3 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Park Namyeol takes over at KHNP",
            author: "footballgirl",
           date: "March, 2026",
            image: "images/wk/3a.jpg",
             content: `<h3>Park Nam-yeol Appointed
              New Manager of Gyeongju KHNP Women</h3>
<p>Veteran coach <strong>Park Nam-yeol</strong> has been officially appointed as the new manager of <strong>Gyeongju Korea Hydro & Nuclear Power Women’s Football Club (Gyeongju KHNP WFC)</strong> ahead of the <strong>2026 WK League</strong> season. The move completes a period of strategic restructuring at the club following the departure of former manager Song Ju-hee, as KHNP prepares to challenge for honours in South Korea’s top tier of women’s football.</p>

<h3>Park’s Playing Career</h3>
<p>Park brings a wealth of experience to Gyeongju, both as a former professional player and as a seasoned coach. Born on <strong>4 May 1970</strong>, he enjoyed an 11-year playing career in the K League, featuring as a midfielder for clubs including <strong>Ilhwa Chunma / Seongnam Ilhwa Chunma</strong> and <strong>Suwon Samsung Bluewings</strong>. During his club career, he won multiple league titles and lifted the Korean FA Cup, as well as earning caps for the <strong>South Korea national team</strong> between 1993 and 1998.</p>

<h3>Coaching Career</h3>
<p>Transitioning into coaching after his retirement, Park has spent much of the past two decades building a reputation in women’s football. He led <strong>Goyang Daekyo Noonnoppi WFC</strong> to a <strong>WK League title in 2011</strong> and has held numerous managerial roles, including at <strong>Icheon Daekyo WFC</strong> and a stint in charge of the <strong>South Korea women’s national team</strong> in 2012. His extensive leadership across both youth and professional levels makes him one of the most respected figures in the sport domestically.</p>

<h3>KHNP’s Recent Performance</h3>
<p>The timing of Park’s appointment comes after Gyeongju KHNP finished <strong>4th in the 2025 WK League season</strong>, consolidating themselves as a competitive force in the league and aiming to build on that foundation. His task will be to guide the club through a full campaign with fresh tactical direction and renewed ambition, while retaining the club’s identity and competitive spirit. The league itself remains one of the most dynamic women’s competitions in Asia, featuring eight teams and attracting growing attention from both fans and players alike.</p>

<h3>Expectations for 2026</h3>
<p>With the 2026 season on the horizon, expectations are high that Park’s leadership will be central to KHNP’s efforts to push for a top-place finish and potentially challenge for the championship. His blend of coaching pedigree, managerial experience, and deep understanding of the women’s game makes him a compelling choice to lead the club forward.</p>
<h3>박남열, 경주 한국수력원자력 여자축구단 신임 감독으로 선임</h3>
<p>베테랑 축구 지도자 <strong>박남열</strong> 
감독이 <strong>경주 한국수력원자력 여자축구단 (Gyeongju KHNP WFC)</strong>
의 신임 사령탑으로 2026년 <strong>WK리그</strong>
 시즌을 앞두고 공식 선임되었다. 이번 선임은 구단의 전략적 재정비의
  일환으로 이루어졌으며 지난 시즌 팀이 4위로 마감한 이후 새로운 
  리더십을 찾던 과정의 결실이다. </p>

<h3>박남열 감독의 선수 경력</h3>
<p>박남열 감독은 <strong>1970년 5월 4일</strong> 
출생으로, 현역 시절 미드필더로 활약하며 K리그에서 오랜 선수 생활을 보냈다.
 그는 <strong>일화 천마(현 성남 FC)</strong>, 
 <strong>상무</strong>, <strong>성남 일화 천마</strong>, 
 <strong>수원 삼성 블루윙즈</strong> 등에서 뛰었으며 특히
  성남 일화 천마에서 여러 차례 리그 우승을 경험
  했다. 또한 1993년부터 1998년까지 대한민국 A대표팀에서 
  활약하며 국가대표로도 뛰었다. </p>

<h3>지도자로서의 경력</h3>
<p>선수 은퇴 후 박 감독은 지도자로
 전향해 오랜 기간 여자 축구계에서 활약했다. 그는 
 <strong>고양 대교 누노피 여자축구단</strong>을
  이끌며 2011년 WK리그 우승을 차지했고, 2012년에는
   <strong>대한민국 여자 대표팀</strong> 감독을 역임한 바 있다. 이후 <strong>
   이천 대교 WFC</strong> 등 여러 팀을 지휘하며 선수단 전술과 경기운영
    능력을 검증받았다. </p>

<h3>경주 한국수력원자력 여자축구단의 현황</h3>
<p><strong>경주 한국수력원자력 여자축구단</strong>은 2017년에
 창단된 WK리그 소속 여자 축구단으로, 대한민국 여자 축구 최고 수준의
  리그에 참가하고 있다. 구단은 경주풋볼파크를 홈 
  구장으로 사용하며 8개 팀이 경쟁하는 WK리그에서 지난 2025 시즌 
  4위로 마무리했다. </p>

<h3>2026 시즌 기대</h3>
<p>박남열 감독의 부임으로 팀은 전술적 안정과 
경쟁력 향상을 목표로 2026 시즌을 준비하고 있다.
 새 시즌은 팀 전력 정비와 함께 강력한 플레이오프 도전이 기대되며,
  박 감독의 지도력과 풍부한 경험이 경주 한수원의 상위권 도약에 핵심 
  역할을 할 것으로 예상된다. </p>


`,
           
              tags: ["Park Nam-yeol", 
                "Gyeongju KHNP WFC",
                "AFC Women’s Asian Cup", "WK League 2026", 
                "Women’s Football Korea","경주 한국수력원자력 여자축구단",
                "박남열",
                "2026 WK리그","한국 여자축구", "축구 지도자"],
 navIndices: { prev: 'wk-2', next: 'wk-4' }
        });
    }

    init() {
        console.log('ArticlePageWK3 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to WK League
            
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'wk' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_wk.png';
            leagueLogo.alt = 'WK League';
        }
    }
}